import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const deviceTypesConstants = {
    DEVICETYPES_LOADED: 'DEVICETYPES_LOADED',
    DEVICETYPE_CREATED: 'DEVICETYPE_CREATED',
    DEVICETYPE_UPDATED: 'DEVICETYPE_UPDATED',
    DEVICETYPE_DELETED: 'DEVICETYPE_DELETED'
};

export const deviceTypesFulfilledConstants = getActionTypesResult(deviceTypesConstants, '_FULFILLED');

export const deviceTypesRejectedConstants = getActionTypesResult(deviceTypesConstants, '_REJECTED');

export const deviceTypesPendingConstants = getActionTypesResult(deviceTypesConstants, '_PENDING');

export const fetchDeviceTypes = createAsyncAction(deviceTypesConstants.DEVICETYPES_LOADED, () =>
    api.get(`deviceTypes`).then(res => res.data)
);

export const fetchMobileDeviceTypes = createAsyncAction(deviceTypesConstants.DEVICETYPES_LOADED, () =>
    api.get(`mobileDeviceTypes`).then(res => res.data)
);

export const fetchLicenseManufacturers = createAsyncAction(deviceTypesConstants.DEVICETYPES_LOADED, () =>
    api.get('licenseManufacturer').then(res => res.data)
);

export const fetchMobileVersions = createAsyncAction(deviceTypesConstants.DEVICETYPES_LOADED, () =>
    api.get('osVersions').then(res => res.data)
);

export const saveDeviceType = createAsyncAction(deviceTypesConstants.DEVICETYPE_CREATED, deviceType =>
    api.post('deviceTypes', deviceType).then(res => res.data)
);

export const saveMobileDeviceType = createAsyncAction(deviceTypesConstants.DEVICETYPE_CREATED, deviceType =>
    api.post('mobileDeviceTypes', deviceType).then(res => res.data)
);

export const saveLicenseManufacturer = createAsyncAction(deviceTypesConstants.DEVICETYPE_CREATED, manufacturer =>
    api.post('licenseManufacturer', manufacturer).then(res => res.data)
);

export const saveMobileVersion = createAsyncAction(deviceTypesConstants.DEVICETYPE_CREATED, version =>
    api.post(`osVersions/${version.name}`).then(res => res.data)
);

export const updateDeviceType = createAsyncAction(deviceTypesConstants.DEVICETYPE_UPDATED, (deviceTypeId, deviceType) =>
    api.put(`deviceTypes`, deviceType).then(res => res.data)
);

export const updateMobileDeviceType = createAsyncAction(
    deviceTypesConstants.DEVICETYPE_UPDATED,
    (deviceTypeId, deviceType) => api.put(`mobileDeviceTypes/${deviceTypeId}`, deviceType).then(res => res.data)
);

export const updateLicenseManufacturer = createAsyncAction(
    deviceTypesConstants.DEVICETYPE_UPDATED,
    (manufacturerId, manufacturer) =>
        api.put(`licenseManufacturer/${manufacturerId}`, manufacturer).then(res => res.data)
);

export const deleteDeviceType = createAsyncAction(deviceTypesConstants.DEVICETYPE_DELETED, deviceType =>
    api.delete(`deviceTypes/${deviceType.id}`).then(() => deviceType.id)
);

export const deleteMobileDeviceType = createAsyncAction(deviceTypesConstants.DEVICETYPE_DELETED, deviceType =>
    api.delete(`mobileDeviceTypes/${deviceType.id}`).then(() => deviceType.id)
);

export const deleteLicenseManufacturer = createAsyncAction(deviceTypesConstants.DEVICETYPE_DELETED, manufacturer =>
    api.delete(`licenseManufacturer/${manufacturer.id}`).then(() => manufacturer.id)
);

export const deleteMobileOSVersion = createAsyncAction(deviceTypesConstants.DEVICETYPE_DELETED, version =>
    api.delete(`osVersions/${version.id}`).then(() => version.id)
);
